/**
 * The platform fee is a backend setting (per store or global), so it is read
 * back from the price estimate rather than hardcoded: the estimate returns the
 * organizer's net for a given fan price.
 */
export const getPlatformFeePercent = (
  price: number,
  netProfit: number
): number => {
  if (!(price > 0) || !(netProfit >= 0) || netProfit > price) {
    return 0;
  }
  return Math.round((1 - netProfit / price) * 100);
};

/** Copy of the "Platform Fee" tooltip, one entry per paragraph. */
export const getPlatformFeeCopy = (feePercent: number): string[] => [
  `MILLIONS applies a ${feePercent}% platform fee to all Pay-Per-View (PPV) purchases. This fee helps cover payment processing, streaming infrastructure, and platform support.`,
  `Creators keep ${
    100 - feePercent
  }% of every PPV sale, with earnings calculated automatically at checkout.`,
];
